/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ScanRouteImport } from './routes/scan'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminVoidLogRouteImport } from './routes/admin/void-log'
import { Route as AdminStaffRouteImport } from './routes/admin/staff'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminReportsRouteImport } from './routes/admin/reports'
import { Route as AdminOnlineOrdersRouteImport } from './routes/admin/online-orders'
import { Route as AdminMenuRouteImport } from './routes/admin/menu'
import { Route as AdminMarketingRouteImport } from './routes/admin/marketing'
import { Route as AdminInventoryRouteImport } from './routes/admin/inventory'
import { Route as AdminExpensesRouteImport } from './routes/admin/expenses'
import { Route as AdminDeliveryZonesRouteImport } from './routes/admin/delivery-zones'
import { Route as AdminDayCloseRouteImport } from './routes/admin/day-close'
import { Route as AdminDashboardRouteImport } from './routes/admin/dashboard'
import { Route as AdminCustomersRouteImport } from './routes/admin/customers'
import { Route as AdminCounterRouteImport } from './routes/admin/counter'
import { Route as AdminCatalogRouteImport } from './routes/admin/catalog'
import { Route as AdminCardPromosRouteImport } from './routes/admin/card-promos'
import { Route as AdminMarketingSegmentsRouteImport } from './routes/admin/marketing.segments'
import { Route as AdminMarketingQrCodesRouteImport } from './routes/admin/marketing.qr-codes'
import { Route as AdminMarketingPromoCodesRouteImport } from './routes/admin/marketing.promo-codes'
import { Route as AdminMarketingPostersRouteImport } from './routes/admin/marketing.posters'
import { Route as AdminMarketingOverviewRouteImport } from './routes/admin/marketing.overview'
import { Route as AdminMarketingMembersRouteImport } from './routes/admin/marketing.members'
import { Route as AdminMarketingLoyaltyRouteImport } from './routes/admin/marketing.loyalty'
import { Route as AdminMarketingEnrolmentRouteImport } from './routes/admin/marketing.enrolment'
import { Route as AdminMarketingCardPromosRouteImport } from './routes/admin/marketing.card-promos'
import { Route as AdminMarketingCampaignsRouteImport } from './routes/admin/marketing.campaigns'

const ScanRoute = ScanRouteImport.update({
  id: '/scan',
  path: '/scan',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminVoidLogRoute = AdminVoidLogRouteImport.update({
  id: '/void-log',
  path: '/void-log',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStaffRoute = AdminStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReportsRoute = AdminReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOnlineOrdersRoute = AdminOnlineOrdersRouteImport.update({
  id: '/online-orders',
  path: '/online-orders',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMenuRoute = AdminMenuRouteImport.update({
  id: '/menu',
  path: '/menu',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMarketingRoute = AdminMarketingRouteImport.update({
  id: '/marketing',
  path: '/marketing',
  getParentRoute: () => AdminRoute,
} as any)
const AdminInventoryRoute = AdminInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AdminRoute,
} as any)
const AdminExpensesRoute = AdminExpensesRouteImport.update({
  id: '/expenses',
  path: '/expenses',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDeliveryZonesRoute = AdminDeliveryZonesRouteImport.update({
  id: '/delivery-zones',
  path: '/delivery-zones',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDayCloseRoute = AdminDayCloseRouteImport.update({
  id: '/day-close',
  path: '/day-close',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDashboardRoute = AdminDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCustomersRoute = AdminCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCounterRoute = AdminCounterRouteImport.update({
  id: '/counter',
  path: '/counter',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCatalogRoute = AdminCatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCardPromosRoute = AdminCardPromosRouteImport.update({
  id: '/card-promos',
  path: '/card-promos',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMarketingSegmentsRoute = AdminMarketingSegmentsRouteImport.update({
  id: '/segments',
  path: '/segments',
  getParentRoute: () => AdminMarketingRoute,
} as any)
const AdminMarketingQrCodesRoute = AdminMarketingQrCodesRouteImport.update({
  id: '/qr-codes',
  path: '/qr-codes',
  getParentRoute: () => AdminMarketingRoute,
} as any)
const AdminMarketingPromoCodesRoute =
  AdminMarketingPromoCodesRouteImport.update({
    id: '/promo-codes',
    path: '/promo-codes',
    getParentRoute: () => AdminMarketingRoute,
  } as any)
const AdminMarketingPostersRoute = AdminMarketingPostersRouteImport.update({
  id: '/posters',
  path: '/posters',
  getParentRoute: () => AdminMarketingRoute,
} as any)
const AdminMarketingOverviewRoute = AdminMarketingOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => AdminMarketingRoute,
} as any)
const AdminMarketingMembersRoute = AdminMarketingMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AdminMarketingRoute,
} as any)
const AdminMarketingLoyaltyRoute = AdminMarketingLoyaltyRouteImport.update({
  id: '/loyalty',
  path: '/loyalty',
  getParentRoute: () => AdminMarketingRoute,
} as any)
const AdminMarketingEnrolmentRoute = AdminMarketingEnrolmentRouteImport.update({
  id: '/enrolment',
  path: '/enrolment',
  getParentRoute: () => AdminMarketingRoute,
} as any)
const AdminMarketingCardPromosRoute =
  AdminMarketingCardPromosRouteImport.update({
    id: '/card-promos',
    path: '/card-promos',
    getParentRoute: () => AdminMarketingRoute,
  } as any)
const AdminMarketingCampaignsRoute = AdminMarketingCampaignsRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => AdminMarketingRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/scan': typeof ScanRoute
  '/admin/card-promos': typeof AdminCardPromosRoute
  '/admin/catalog': typeof AdminCatalogRoute
  '/admin/counter': typeof AdminCounterRoute
  '/admin/customers': typeof AdminCustomersRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/day-close': typeof AdminDayCloseRoute
  '/admin/delivery-zones': typeof AdminDeliveryZonesRoute
  '/admin/expenses': typeof AdminExpensesRoute
  '/admin/inventory': typeof AdminInventoryRoute
  '/admin/marketing': typeof AdminMarketingRouteWithChildren
  '/admin/menu': typeof AdminMenuRoute
  '/admin/online-orders': typeof AdminOnlineOrdersRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/staff': typeof AdminStaffRoute
  '/admin/void-log': typeof AdminVoidLogRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/marketing/campaigns': typeof AdminMarketingCampaignsRoute
  '/admin/marketing/card-promos': typeof AdminMarketingCardPromosRoute
  '/admin/marketing/enrolment': typeof AdminMarketingEnrolmentRoute
  '/admin/marketing/loyalty': typeof AdminMarketingLoyaltyRoute
  '/admin/marketing/members': typeof AdminMarketingMembersRoute
  '/admin/marketing/overview': typeof AdminMarketingOverviewRoute
  '/admin/marketing/posters': typeof AdminMarketingPostersRoute
  '/admin/marketing/promo-codes': typeof AdminMarketingPromoCodesRoute
  '/admin/marketing/qr-codes': typeof AdminMarketingQrCodesRoute
  '/admin/marketing/segments': typeof AdminMarketingSegmentsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/scan': typeof ScanRoute
  '/admin/card-promos': typeof AdminCardPromosRoute
  '/admin/catalog': typeof AdminCatalogRoute
  '/admin/counter': typeof AdminCounterRoute
  '/admin/customers': typeof AdminCustomersRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/day-close': typeof AdminDayCloseRoute
  '/admin/delivery-zones': typeof AdminDeliveryZonesRoute
  '/admin/expenses': typeof AdminExpensesRoute
  '/admin/inventory': typeof AdminInventoryRoute
  '/admin/marketing': typeof AdminMarketingRouteWithChildren
  '/admin/menu': typeof AdminMenuRoute
  '/admin/online-orders': typeof AdminOnlineOrdersRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/staff': typeof AdminStaffRoute
  '/admin/void-log': typeof AdminVoidLogRoute
  '/admin': typeof AdminIndexRoute
  '/admin/marketing/campaigns': typeof AdminMarketingCampaignsRoute
  '/admin/marketing/card-promos': typeof AdminMarketingCardPromosRoute
  '/admin/marketing/enrolment': typeof AdminMarketingEnrolmentRoute
  '/admin/marketing/loyalty': typeof AdminMarketingLoyaltyRoute
  '/admin/marketing/members': typeof AdminMarketingMembersRoute
  '/admin/marketing/overview': typeof AdminMarketingOverviewRoute
  '/admin/marketing/posters': typeof AdminMarketingPostersRoute
  '/admin/marketing/promo-codes': typeof AdminMarketingPromoCodesRoute
  '/admin/marketing/qr-codes': typeof AdminMarketingQrCodesRoute
  '/admin/marketing/segments': typeof AdminMarketingSegmentsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/scan': typeof ScanRoute
  '/admin/card-promos': typeof AdminCardPromosRoute
  '/admin/catalog': typeof AdminCatalogRoute
  '/admin/counter': typeof AdminCounterRoute
  '/admin/customers': typeof AdminCustomersRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/day-close': typeof AdminDayCloseRoute
  '/admin/delivery-zones': typeof AdminDeliveryZonesRoute
  '/admin/expenses': typeof AdminExpensesRoute
  '/admin/inventory': typeof AdminInventoryRoute
  '/admin/marketing': typeof AdminMarketingRouteWithChildren
  '/admin/menu': typeof AdminMenuRoute
  '/admin/online-orders': typeof AdminOnlineOrdersRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/staff': typeof AdminStaffRoute
  '/admin/void-log': typeof AdminVoidLogRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/marketing/campaigns': typeof AdminMarketingCampaignsRoute
  '/admin/marketing/card-promos': typeof AdminMarketingCardPromosRoute
  '/admin/marketing/enrolment': typeof AdminMarketingEnrolmentRoute
  '/admin/marketing/loyalty': typeof AdminMarketingLoyaltyRoute
  '/admin/marketing/members': typeof AdminMarketingMembersRoute
  '/admin/marketing/overview': typeof AdminMarketingOverviewRoute
  '/admin/marketing/posters': typeof AdminMarketingPostersRoute
  '/admin/marketing/promo-codes': typeof AdminMarketingPromoCodesRoute
  '/admin/marketing/qr-codes': typeof AdminMarketingQrCodesRoute
  '/admin/marketing/segments': typeof AdminMarketingSegmentsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/scan'
    | '/admin/card-promos'
    | '/admin/catalog'
    | '/admin/counter'
    | '/admin/customers'
    | '/admin/dashboard'
    | '/admin/day-close'
    | '/admin/delivery-zones'
    | '/admin/expenses'
    | '/admin/inventory'
    | '/admin/marketing'
    | '/admin/menu'
    | '/admin/online-orders'
    | '/admin/reports'
    | '/admin/settings'
    | '/admin/staff'
    | '/admin/void-log'
    | '/admin/'
    | '/admin/marketing/campaigns'
    | '/admin/marketing/card-promos'
    | '/admin/marketing/enrolment'
    | '/admin/marketing/loyalty'
    | '/admin/marketing/members'
    | '/admin/marketing/overview'
    | '/admin/marketing/posters'
    | '/admin/marketing/promo-codes'
    | '/admin/marketing/qr-codes'
    | '/admin/marketing/segments'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/scan'
    | '/admin/card-promos'
    | '/admin/catalog'
    | '/admin/counter'
    | '/admin/customers'
    | '/admin/dashboard'
    | '/admin/day-close'
    | '/admin/delivery-zones'
    | '/admin/expenses'
    | '/admin/inventory'
    | '/admin/marketing'
    | '/admin/menu'
    | '/admin/online-orders'
    | '/admin/reports'
    | '/admin/settings'
    | '/admin/staff'
    | '/admin/void-log'
    | '/admin'
    | '/admin/marketing/campaigns'
    | '/admin/marketing/card-promos'
    | '/admin/marketing/enrolment'
    | '/admin/marketing/loyalty'
    | '/admin/marketing/members'
    | '/admin/marketing/overview'
    | '/admin/marketing/posters'
    | '/admin/marketing/promo-codes'
    | '/admin/marketing/qr-codes'
    | '/admin/marketing/segments'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/scan'
    | '/admin/card-promos'
    | '/admin/catalog'
    | '/admin/counter'
    | '/admin/customers'
    | '/admin/dashboard'
    | '/admin/day-close'
    | '/admin/delivery-zones'
    | '/admin/expenses'
    | '/admin/inventory'
    | '/admin/marketing'
    | '/admin/menu'
    | '/admin/online-orders'
    | '/admin/reports'
    | '/admin/settings'
    | '/admin/staff'
    | '/admin/void-log'
    | '/admin/'
    | '/admin/marketing/campaigns'
    | '/admin/marketing/card-promos'
    | '/admin/marketing/enrolment'
    | '/admin/marketing/loyalty'
    | '/admin/marketing/members'
    | '/admin/marketing/overview'
    | '/admin/marketing/posters'
    | '/admin/marketing/promo-codes'
    | '/admin/marketing/qr-codes'
    | '/admin/marketing/segments'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  ScanRoute: typeof ScanRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/scan': {
      id: '/scan'
      path: '/scan'
      fullPath: '/scan'
      preLoaderRoute: typeof ScanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/void-log': {
      id: '/admin/void-log'
      path: '/void-log'
      fullPath: '/admin/void-log'
      preLoaderRoute: typeof AdminVoidLogRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/staff': {
      id: '/admin/staff'
      path: '/staff'
      fullPath: '/admin/staff'
      preLoaderRoute: typeof AdminStaffRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/reports': {
      id: '/admin/reports'
      path: '/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof AdminReportsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/online-orders': {
      id: '/admin/online-orders'
      path: '/online-orders'
      fullPath: '/admin/online-orders'
      preLoaderRoute: typeof AdminOnlineOrdersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/menu': {
      id: '/admin/menu'
      path: '/menu'
      fullPath: '/admin/menu'
      preLoaderRoute: typeof AdminMenuRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/marketing': {
      id: '/admin/marketing'
      path: '/marketing'
      fullPath: '/admin/marketing'
      preLoaderRoute: typeof AdminMarketingRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/inventory': {
      id: '/admin/inventory'
      path: '/inventory'
      fullPath: '/admin/inventory'
      preLoaderRoute: typeof AdminInventoryRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/expenses': {
      id: '/admin/expenses'
      path: '/expenses'
      fullPath: '/admin/expenses'
      preLoaderRoute: typeof AdminExpensesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/delivery-zones': {
      id: '/admin/delivery-zones'
      path: '/delivery-zones'
      fullPath: '/admin/delivery-zones'
      preLoaderRoute: typeof AdminDeliveryZonesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/day-close': {
      id: '/admin/day-close'
      path: '/day-close'
      fullPath: '/admin/day-close'
      preLoaderRoute: typeof AdminDayCloseRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/dashboard': {
      id: '/admin/dashboard'
      path: '/dashboard'
      fullPath: '/admin/dashboard'
      preLoaderRoute: typeof AdminDashboardRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/customers': {
      id: '/admin/customers'
      path: '/customers'
      fullPath: '/admin/customers'
      preLoaderRoute: typeof AdminCustomersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/counter': {
      id: '/admin/counter'
      path: '/counter'
      fullPath: '/admin/counter'
      preLoaderRoute: typeof AdminCounterRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/catalog': {
      id: '/admin/catalog'
      path: '/catalog'
      fullPath: '/admin/catalog'
      preLoaderRoute: typeof AdminCatalogRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/card-promos': {
      id: '/admin/card-promos'
      path: '/card-promos'
      fullPath: '/admin/card-promos'
      preLoaderRoute: typeof AdminCardPromosRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/marketing/segments': {
      id: '/admin/marketing/segments'
      path: '/segments'
      fullPath: '/admin/marketing/segments'
      preLoaderRoute: typeof AdminMarketingSegmentsRouteImport
      parentRoute: typeof AdminMarketingRoute
    }
    '/admin/marketing/qr-codes': {
      id: '/admin/marketing/qr-codes'
      path: '/qr-codes'
      fullPath: '/admin/marketing/qr-codes'
      preLoaderRoute: typeof AdminMarketingQrCodesRouteImport
      parentRoute: typeof AdminMarketingRoute
    }
    '/admin/marketing/promo-codes': {
      id: '/admin/marketing/promo-codes'
      path: '/promo-codes'
      fullPath: '/admin/marketing/promo-codes'
      preLoaderRoute: typeof AdminMarketingPromoCodesRouteImport
      parentRoute: typeof AdminMarketingRoute
    }
    '/admin/marketing/posters': {
      id: '/admin/marketing/posters'
      path: '/posters'
      fullPath: '/admin/marketing/posters'
      preLoaderRoute: typeof AdminMarketingPostersRouteImport
      parentRoute: typeof AdminMarketingRoute
    }
    '/admin/marketing/overview': {
      id: '/admin/marketing/overview'
      path: '/overview'
      fullPath: '/admin/marketing/overview'
      preLoaderRoute: typeof AdminMarketingOverviewRouteImport
      parentRoute: typeof AdminMarketingRoute
    }
    '/admin/marketing/members': {
      id: '/admin/marketing/members'
      path: '/members'
      fullPath: '/admin/marketing/members'
      preLoaderRoute: typeof AdminMarketingMembersRouteImport
      parentRoute: typeof AdminMarketingRoute
    }
    '/admin/marketing/loyalty': {
      id: '/admin/marketing/loyalty'
      path: '/loyalty'
      fullPath: '/admin/marketing/loyalty'
      preLoaderRoute: typeof AdminMarketingLoyaltyRouteImport
      parentRoute: typeof AdminMarketingRoute
    }
    '/admin/marketing/enrolment': {
      id: '/admin/marketing/enrolment'
      path: '/enrolment'
      fullPath: '/admin/marketing/enrolment'
      preLoaderRoute: typeof AdminMarketingEnrolmentRouteImport
      parentRoute: typeof AdminMarketingRoute
    }
    '/admin/marketing/card-promos': {
      id: '/admin/marketing/card-promos'
      path: '/card-promos'
      fullPath: '/admin/marketing/card-promos'
      preLoaderRoute: typeof AdminMarketingCardPromosRouteImport
      parentRoute: typeof AdminMarketingRoute
    }
    '/admin/marketing/campaigns': {
      id: '/admin/marketing/campaigns'
      path: '/campaigns'
      fullPath: '/admin/marketing/campaigns'
      preLoaderRoute: typeof AdminMarketingCampaignsRouteImport
      parentRoute: typeof AdminMarketingRoute
    }
  }
}

interface AdminMarketingRouteChildren {
  AdminMarketingCampaignsRoute: typeof AdminMarketingCampaignsRoute
  AdminMarketingCardPromosRoute: typeof AdminMarketingCardPromosRoute
  AdminMarketingEnrolmentRoute: typeof AdminMarketingEnrolmentRoute
  AdminMarketingLoyaltyRoute: typeof AdminMarketingLoyaltyRoute
  AdminMarketingMembersRoute: typeof AdminMarketingMembersRoute
  AdminMarketingOverviewRoute: typeof AdminMarketingOverviewRoute
  AdminMarketingPostersRoute: typeof AdminMarketingPostersRoute
  AdminMarketingPromoCodesRoute: typeof AdminMarketingPromoCodesRoute
  AdminMarketingQrCodesRoute: typeof AdminMarketingQrCodesRoute
  AdminMarketingSegmentsRoute: typeof AdminMarketingSegmentsRoute
}

const AdminMarketingRouteChildren: AdminMarketingRouteChildren = {
  AdminMarketingCampaignsRoute: AdminMarketingCampaignsRoute,
  AdminMarketingCardPromosRoute: AdminMarketingCardPromosRoute,
  AdminMarketingEnrolmentRoute: AdminMarketingEnrolmentRoute,
  AdminMarketingLoyaltyRoute: AdminMarketingLoyaltyRoute,
  AdminMarketingMembersRoute: AdminMarketingMembersRoute,
  AdminMarketingOverviewRoute: AdminMarketingOverviewRoute,
  AdminMarketingPostersRoute: AdminMarketingPostersRoute,
  AdminMarketingPromoCodesRoute: AdminMarketingPromoCodesRoute,
  AdminMarketingQrCodesRoute: AdminMarketingQrCodesRoute,
  AdminMarketingSegmentsRoute: AdminMarketingSegmentsRoute,
}

const AdminMarketingRouteWithChildren = AdminMarketingRoute._addFileChildren(
  AdminMarketingRouteChildren,
)

interface AdminRouteChildren {
  AdminCardPromosRoute: typeof AdminCardPromosRoute
  AdminCatalogRoute: typeof AdminCatalogRoute
  AdminCounterRoute: typeof AdminCounterRoute
  AdminCustomersRoute: typeof AdminCustomersRoute
  AdminDashboardRoute: typeof AdminDashboardRoute
  AdminDayCloseRoute: typeof AdminDayCloseRoute
  AdminDeliveryZonesRoute: typeof AdminDeliveryZonesRoute
  AdminExpensesRoute: typeof AdminExpensesRoute
  AdminInventoryRoute: typeof AdminInventoryRoute
  AdminMarketingRoute: typeof AdminMarketingRouteWithChildren
  AdminMenuRoute: typeof AdminMenuRoute
  AdminOnlineOrdersRoute: typeof AdminOnlineOrdersRoute
  AdminReportsRoute: typeof AdminReportsRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminStaffRoute: typeof AdminStaffRoute
  AdminVoidLogRoute: typeof AdminVoidLogRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminCardPromosRoute: AdminCardPromosRoute,
  AdminCatalogRoute: AdminCatalogRoute,
  AdminCounterRoute: AdminCounterRoute,
  AdminCustomersRoute: AdminCustomersRoute,
  AdminDashboardRoute: AdminDashboardRoute,
  AdminDayCloseRoute: AdminDayCloseRoute,
  AdminDeliveryZonesRoute: AdminDeliveryZonesRoute,
  AdminExpensesRoute: AdminExpensesRoute,
  AdminInventoryRoute: AdminInventoryRoute,
  AdminMarketingRoute: AdminMarketingRouteWithChildren,
  AdminMenuRoute: AdminMenuRoute,
  AdminOnlineOrdersRoute: AdminOnlineOrdersRoute,
  AdminReportsRoute: AdminReportsRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminStaffRoute: AdminStaffRoute,
  AdminVoidLogRoute: AdminVoidLogRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  ScanRoute: ScanRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
